import { AdmService } from 'src/app/shared/services/adm.service';
import { Component, OnInit } from '@angular/core';
import { ConfigService } from 'src/app/shared/services/config.service';
import { forkJoin } from 'rxjs';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { IChangePassword } from '../../shared/interfaces/IChangePassword';
import { LoggedService } from 'src/app/shared/services/logged.service';
import { passwordValidator, compareValidator, passwordValidatorOld, isMobile } from 'src/app/shared/utils/helpers';
import { Router } from '@angular/router';
import { SidenavService } from 'src/app/shared/services/sidenav.service';
import { SnackbarService } from '../../shared/services/snackbar.service';
import { UsuariosService } from 'src/app/shared/services/usuarios.service';

@Component({
    templateUrl: './cambioclave.component.html',
})

export class CambioClaveComponent implements OnInit {
    form: FormGroup;
    color1: string;
    color2: string;
    color3: string;
    hide1 = true;
    hide2 = true;
    hide3 = true;
    icon1: string;
    value1: string = "";
    icon2: string;
    icon3: string;
    nuevaClaveNumeros: boolean = false;
    nuevaClaveMinusculas: boolean = false;
    nuevaClaveMayusculas: boolean = false;
    nuevaClaveCaracteresEspeciales: boolean = false;
    public Etiquetas: {
        Boton: string
        ClaveActual: string,
        ClaveNueva: string,
        RepetirClaveNueva: string,
        Ayuda: string
        MailContacto: string
        LeadText1: string
        LeadText2: string
        LeadText3: string
        LeadText4: string
        LogoBayerBlanco: string
        LogoBayerColor: string
    }

    public Validaciones: {

        ConfirmacionClaveNueva: string
        EscribirClave: string
        ValidacionClaveNueva: string[]
        ValidacionClaveNueva1: string,
        ValidacionClaveNueva2: string,
        ValidacionClaveNueva3: string,
        ValidacionClaveNueva4: string,
        ValidacionClaveNueva5: string,

    }

    constructor(
        private admService: AdmService,
        private configService: ConfigService,
        private fb: FormBuilder,
        private loggedService: LoggedService,
        private router: Router,
        private sidenav: SidenavService,
        private usuarioService: UsuariosService,
        private snackBarService: SnackbarService
    ) { }

    ngOnInit() {
        if (typeof this.loggedService.logged == 'undefined' || this.loggedService.logged == null) {
            localStorage.setItem('logoutLogs', JSON.stringify(
            {
                timestamp: new Date(),
                reasonId: 0,
                source: 'cambioclave.component.ts ngOnInit'
            }
            ));
            
            this.loggedService.logOut(0);
        }

        //this.loadScripts();
        this.icon1 = "clear";
        this.icon2 = "clear";
        this.icon3 = "clear";
        this.color1 = "black";
        this.color2 = "black";
        this.color3 = "black";

        this.Validaciones = {
            EscribirClave: this.configService.validaciones.CambiarClave.EscribirClave,
            ValidacionClaveNueva: this.configService.validaciones.CambiarClave.ValidacionClaveNueva,
            ValidacionClaveNueva1: this.configService.validaciones.CambiarClave.ValidacionClaveNueva1,
            ValidacionClaveNueva2: this.configService.validaciones.CambiarClave.ValidacionClaveNueva2,
            ValidacionClaveNueva3: this.configService.validaciones.CambiarClave.ValidacionClaveNueva3,
            ValidacionClaveNueva4: this.configService.validaciones.CambiarClave.ValidacionClaveNueva4,
            ValidacionClaveNueva5: this.configService.validaciones.CambiarClave.ValidacionClaveNueva5,
            ConfirmacionClaveNueva: this.configService.validaciones.CambiarClave.ConfirmacionClaveNueva
        }
        this.Etiquetas = {
            Ayuda: this.configService.etiquetas.CambiarClave.Ayuda,
            ClaveActual: this.configService.etiquetas.CambiarClave.ClaveActual,
            ClaveNueva: this.configService.etiquetas.CambiarClave.ClaveNueva,
            RepetirClaveNueva: this.configService.etiquetas.CambiarClave.RepetirClaveNueva,
            Boton: this.configService.etiquetas.CambiarClave.Boton,
            LeadText1: this.configService.etiquetas.CambiarClave.LeadText1,
            LeadText2: this.configService.etiquetas.CambiarClave.LeadText2,
            LeadText3: this.configService.etiquetas.CambiarClave.LeadText3,
            LeadText4: this.isNewUser() ? this.configService.etiquetas.CambiarClave.LeadText5 : this.configService.etiquetas.CambiarClave.LeadText4,
            LogoBayerBlanco: this.configService.etiquetas.LogoBayerBlanco,
            MailContacto: this.configService.etiquetas.MailContacto,
            LogoBayerColor: this.configService.etiquetas.LogoBayerColor,
        }

        this.form = this.fb.group({
            CurrentPassword: ['', [
                Validators.required,
                Validators.minLength(8),
                Validators.maxLength(15),
                passwordValidatorOld
            ]],
            NewPassword: ['', [
                Validators.required,
                Validators.minLength(8),
                Validators.maxLength(15),
                passwordValidator
            ]],
            NewPasswordConfirmed: ['', [
                Validators.required,
                passwordValidator
            ]]
        }, {
            validator: compareValidator('NewPassword', 'NewPasswordConfirmed')
        });
    }

    get currentPassword() {
        return this.form.controls.CurrentPassword;
    }

    get newPassword() {
        return this.form.controls.NewPassword;
    }

    get newPasswordConfirmed() {
        return this.form.controls.NewPasswordConfirmed;
    }

    isMobile() {
        return isMobile();
    }

    setCheckboxes() {
        var LOWERCASE_REGEX = /[a-z]/
        var UPPERCASE_REGEX = /[A-Z]/
        var DIGIT_REGEX = /(\d)/
        var SPECIAL_REGEX = /[\!\#\$(\)\*\+\-\=\<\>\?_\{\}\~]/

        if (this.value1.length) {
            this.nuevaClaveNumeros = DIGIT_REGEX.test(this.value1);
            this.nuevaClaveMayusculas = UPPERCASE_REGEX.test(this.value1);
            this.nuevaClaveMinusculas = LOWERCASE_REGEX.test(this.value1);
            this.nuevaClaveCaracteresEspeciales = SPECIAL_REGEX.test(this.value1);
        }
        else {
            this.nuevaClaveNumeros = false;
            this.nuevaClaveMayusculas = false;
            this.nuevaClaveMinusculas = false;
            this.nuevaClaveCaracteresEspeciales = false;
        }

    }

    onSubmit() {


        const form: IChangePassword = this.form.value;

        form.Id = this.loggedService.logged.id;
        let NewUser: boolean = false
        NewUser = this.loggedService.logged.newUser;
        this.usuarioService
            .changePassword(form)
            .subscribe(() => {
                if (NewUser) {
                    this.snackBarService.openSnackbar(this.configService.mensajes.TituloClaveModificada, this.configService.mensajes.LoginUsuario.ClaveModificada, 1, 1);
                }
                else {
                    this.snackBarService.openSnackbar(this.configService.mensajes.TituloClaveModificada, this.configService.mensajes.LoginUsuario.ClaveModificada2, 1, 1);
                }
                localStorage.setItem('logoutLogs', JSON.stringify(
                {
                    timestamp: new Date(),
                    reasonId: 0,
                    source: 'cambioclave.component.ts onSubmit'
                }
                ));
    
                this.loggedService.logOut(0);
            });


    }

    isLogged() {
        return this.loggedService.logged != null;
    }

    isNewUser() {
        if (this.loggedService.logged != null) {
            return this.loggedService.logged.newUser;
        }
        else {
            return false
        }
    }

    toggleRightSidenav() {
        this.sidenav.toggle();
    }
}
